eshopApp.controller('ProductActionsController', ['$scope', '$http', 'alertMessage', function($scope, $http, alertMessage){

	$scope.add_in_progress = false;

	// Add to cart quantity
	$scope.qty = 1;
        $scope.amount = 0;
        $scope.productWidth = 0;

	// Add to cart
	$scope.addToCart = function(product_id){

		$scope.add_in_progress = true;

		$http.post('/a/add_to_cart', {
			product_id : product_id,
			qty : $scope.qty,
                        amount: $scope.amount
		}).success(function(response){
			if (response.message === 'added') {
				alertMessage.set(response.alert, 'success');
			} else {
				alertMessage.set(generic.error, 'error');
			}
			if (response.stock_is_not_enough) {
				// DevPro3 stock is not enough -> warn user
				alertMessage.set('Tuotteen varastosaldo ylittyi!', 'warning');
			}
	  	}).error(function(response) {
	  		alertMessage.set(generic.error, 'error');
	  	}).finally(function(){
	  		$scope.add_in_progress = false;
	  	});
	};

	// Make reservation
	$scope.makeReservation = function(product_id){
		if (confirm(generic.confirm)) {
			$scope.reservation_in_progress = true;

			$http.post('/a/make_product_reservation', {
				product_id : product_id,
				qty : $scope.qty
			}).success(function(response){
				if (response.message === 'added') {
					alertMessage.set(response.alert, 'success');
				} else {
					alertMessage.set(generic.error, 'error');
				}
		  	}).error(function(response) {
		  		alertMessage.set(generic.error, 'error');
		  	}).finally(function(){
		  		$scope.reservation_in_progress = false;
		  	});
	  	}
	};

    // Decrease Quantity
    $scope.decQty = function() {
        if ($scope.qty > 1) {
            $scope.qty--;
        }
    };
    // Increase Quantity
    $scope.incQty = function() {
        $scope.qty++;
    };

    // Decrease Quantity
    $scope.decAmnt = function() {
        if ($scope.amount > 1) {
            $scope.amount--;
        }
    };
    // Increase Quantity
    $scope.incAmnt = function() {
        $scope.amount++;
    };

}]);
